import { createFileRoute, redirect } from '@tanstack/react-router';
import { LoyaltyPage, loyaltyProgramQueryOptions } from '@/features/loyalty';
import { isMerchantOwner } from '@/lib/auth/rbac';
import { useAuthStore } from '@/stores/auth';

export const Route = createFileRoute('/_authed/loyalty')({
  beforeLoad: () => {
    if (!isMerchantOwner(useAuthStore.getState().user?.role)) {
      throw redirect({
        to: '/dashboard',
        search: { period: 'today' },
        replace: true,
      });
    }
  },
  loader: ({ cause, context }) => {
    if (cause !== 'enter') return;
    void context.queryClient.prefetchQuery(loyaltyProgramQueryOptions());
  },
  component: LoyaltyPage,
});
